import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedUtilsModule } from '@iqd/shared-utils';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbsoluteMoveComponent } from './absolute-move/absolute-move.component';
import { AddCutoutModalComponent } from './add-cutout-modal/add-cutout-modal.component';
import { DrawingSessionService } from './drawing-session.service';
import { FloorRenderingService } from './floor-rendering.service';
import { FloorRenderingComponent } from './floor-rendering/floor-rendering.component';
import { MoveComponentModalComponent } from './move-component-modal/move-component-modal.component';
import { MoveCutoutModalComponent } from './move-cutout-modal/move-cutout-modal.component';
import { RelativeMoveComponent } from './relative-move/relative-move.component';
import { RemoveComponentsModalComponent } from './remove-components-modal/remove-components-modal.component';
import { RendererSettingsModalComponent } from './renderer-settings-modal/renderer-settings-modal.component';
import { ResizeCutoutsModalComponent } from './resize-cutouts-modal/resize-cutouts-modal.component';
import { SelectedComponentModalComponent } from './selected-component-modal/selected-component-modal.component';
import { SelectedComponentsService } from './selected-components.service';
import { TransformComponentsService } from './transform-components.service';
import { TransformsListComponent } from './transforms-list/transforms-list.component';
import { ZoomSliderComponent } from './zoom-slider/zoom-slider.component';

@NgModule({
  declarations: [
    AbsoluteMoveComponent,
    AddCutoutModalComponent,
    FloorRenderingComponent,
    MoveComponentModalComponent,
    MoveCutoutModalComponent,
    RelativeMoveComponent,
    RemoveComponentsModalComponent,
    RendererSettingsModalComponent,
    ResizeCutoutsModalComponent,
    ZoomSliderComponent,
    SelectedComponentModalComponent,
    TransformsListComponent,
  ],
  imports: [
    SharedUtilsModule,
    NgbModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    AddCutoutModalComponent,
    FloorRenderingComponent,
    MoveComponentModalComponent,
    MoveCutoutModalComponent,
    RelativeMoveComponent,
    RemoveComponentsModalComponent,
    RendererSettingsModalComponent,
    ResizeCutoutsModalComponent,
    SelectedComponentModalComponent,
    TransformsListComponent,
  ],
  providers: [
    FloorRenderingService,
    SelectedComponentsService,
    TransformComponentsService,
    DrawingSessionService,
  ],
})
export class SharedDrawingModule {}
